import { Component, OnInit, signal } from '@angular/core';
import { DTO, Types } from 'shared-lib';
import {
  CardComponent,
  FilterComponent,
  helper,
  IconComponent,
  LabelComponent,
  LoadingService,
  PaginationComponent,
  RelativeDatePipe,
  service,
  ToastService,
  types,
} from 'shared';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { catchError, map, of } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'ui-user-list',
  standalone: true,
  imports: [
    CommonModule,
    CardComponent,
    LabelComponent,
    IconComponent,
    FilterComponent,
    PaginationComponent,
    RelativeDatePipe,
  ],
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class UserListComponent implements OnInit {
  loading = signal(true);
  users: DTO.UserDTO[] = [];
  EIconType = types.EIcon;
  ELabelType = types.ELabelType;
  EAlert = Types.EAlert;
  EComponentSize = types.EComponentSize;
  Types = Types;
  itemsPerPage: number = 10;

  //pagination
  current = 1;
  total = 0;

  constructor(
    private http: HttpClient,
    private loadingService: LoadingService,
    private router: Router,
    private toastService: ToastService,
    private chatService: service.ChatService,
    private fileService: service.FileService
  ) {}

  ngOnInit(): void {
    this.getUsers();
  }

  async loadAvatar(id: number | string): Promise<string> {
    let file = await this.fileService.getFileById(id);
    if (file) {
      return file.base64;
    }

    return '';
  }

  async getUsers(data?: any) {
    this.loadingService.start();
    this.users = [];

    let queryParams = '';
    if (data) {
      queryParams = new URLSearchParams(data['filter']).toString();
    }

    this.http
      .get<DTO.PaginationDTO<DTO.UserDTO[]>>(
        `userAccount/user-list?&page=${this.current - 1}&limit=${
          this.itemsPerPage
        }&${queryParams}`
      )
      .pipe(
        map(async (response) => {
          let usersData = response.content;
          this.total = response.total;
          if (usersData && usersData.length > 0) {
            await Promise.all(
              usersData.map(async (user) => {
                let base64 = await this.loadAvatar(user.avatar?.id ?? 0);
                if (user.avatar) {
                  user.avatar.path = base64;
                }
              })
            );

            this.users = usersData;
          }
          return true;
        }),
        catchError((error) => {
          this.users = [];
          return of(false);
        })
      )
      .subscribe();

    this.loadingService.stop();
    this.loading.set(false);
  }

  refresh(event: any) {
    this.current = event;
    this.getUsers();
  }

  filter(event: any) {
    this.getUsers(event);
  }

  goToProfile(id: number) {
    this.router.navigate([`other-user/${id}`]);
  }

  itemsPerPageChange(itemsPerPage: number) {
    this.itemsPerPage = itemsPerPage;
    this.getUsers();
  }

  async buttonPress(event: string, user: DTO.UserDTO) {
    switch (event) {
      case 'chat':
        this.router.navigate([`other-user/${user.id}`]);
        break;

      default:
        break;
    }
  }
}
